/*
 * @Author: Tina Huang
 * @Date: 2024-04-23 12:07:50
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-01-23 15:25:45
 * @Description:
 */
import { Button, Popover, Space, Tag } from 'antd'
import Peep from '../assets/svgs/peep.svg'
export default function PanelMe() {
  const isMobile = window.innerWidth <= 750

  const AboutMe = () => (
    <div>
      <h2 className="font-bold text-xl">阿汪同学（肥汪卷）｜ISFJ</h2>
      <p className="mt-2">持续健身减肥中｜专业技能升级中</p>
      <p className="mt-2">喜欢手帐｜喜欢记录｜喜欢动手</p>
      <p className="mt-2">
        <Tag color="blue">程序员</Tag>
        <Tag color="gold">Notion Creator</Tag>
      </p>
    </div>
  )

  const Content = isMobile ? (
    <>
      <div className="w-full flex items-center justify-center">
        <img src={Peep} className="w-1/3" alt="" />
        <div className="text-center w-2/3">
          <h1 className="text-2xl font-bold">Hi，这里是阿汪同学</h1>
          <p className="mt-2 text-xl">助大家高效组织自己的体系</p>
          {/* contact */}
          <div className="mt-2 flex justify-center">
            <Button type="link">小红书：@肥汪卷</Button>
            <Button type="link" href="https://space.bilibili.com/19225439" target="_blank">
              BiliBili：@阿汪同学
            </Button>
          </div>
        </div>
      </div>
    </>
  ) : (
    <div className="mb-12">
      <div className="flex items-center justify-center">
        <Popover trigger={['hover']} placement="right" content={<AboutMe />}>
          <img src={Peep} className="w-1/3 mr-28" alt="" />
        </Popover>
        <div className="text-center">
          <h1 className="text-6xl font-bold">Hi，这里是阿汪同学</h1>
          <p className="mt-10 text-xl">我在这里发布一些模板，教程以及组件帮助大家高效组织自己的体系</p>
          {/* contact */}
          <div className="mt-10 flex justify-center">
            <Button type="link">小红书：@肥汪卷</Button>
            <Button type="link" href="https://space.bilibili.com/19225439" target="_blank">
              BiliBili：@阿汪同学
            </Button>
            <Button type="link">淘宝：汪汪汪世界</Button>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <Space align="center">
          <strong className="text-6xl font-serif leading-none">4</strong>
          <p className="pl-2">
            年<br></br>Notion使用经验
          </p>
        </Space>
        <Space align="center">
          <strong className="text-6xl font-serif leading-none">100</strong>
          <p className="pl-2">
            +个<br></br>原创模版
          </p>
        </Space>
        <Space align="center">
          <strong className="text-6xl font-serif leading-none">5000</strong>
          <p className="pl-2">
            +份<br></br>模版售出
          </p>
        </Space>
        <Space align="center">
          <strong className="text-6xl font-serif leading-none">100</strong>
          <p className="pl-2">
            +位<br></br>定制用户
          </p>
        </Space>
        <Space align="center">
          <strong className="text-6xl font-serif leading-none">365</strong>
          <p className="pl-2">
            天<br></br>在线服务
          </p>
        </Space>
      </div>
    </div>
  )

  return <>{Content}</>
}
